import { motion } from "framer-motion";
import { equipment } from "../data";

export default function Equipment() {
  return (
    <section className="py-5 text-white" style={{ backgroundColor: '#1e1e2f' }}>
      <div className="container py-5">
        <h2 className="text-center display-5 fw-bold mb-5">Наше оборудование</h2>
        <div className="row g-4">
          {equipment.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.05 }}
              viewport={{ once: true }}
              className="col-sm-6 col-md-4 col-lg-3"
            >
              <div className="bg-white bg-opacity-10 rounded-3 p-3 d-flex align-items-center gap-3 h-100">
                <span className="fs-1 text-danger">🔧</span>
                <span className="fs-6">{item}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}